<div class="auth-modal-container">
  <div class="flex flex-column gap-16">
    <!-- Header con icono y títulos -->
    <div class="flex flex-column gap-12" style="align-items: center">
      <app-icon name="shield" color="#3B82F6" [size]="32"></app-icon>
      <div class="flex flex-column gap-4" style="align-items: center">
        <h3 class="fs-lg text-semibold text-dark">Autenticación Requerida</h3>
        <p class="fs-sm text-light text-center">
          Para acceder a <strong>{{ reportName }}</strong> necesitas autenticarte con <strong>{{ dataSourceProviderName }}</strong>
        </p>
      </div>
    </div>

    <!-- Card informativa -->
    <nz-card [nzBodyStyle]="{padding: '16px', backgroundColor: '#F8FAFC'}" class="no-shadow">
      <div class="flex flex-column gap-8">
          <p class="fs-sm text-dark">
            Debes introducir el usuario y una API Key de Odoo. Si no sabes como generar una puedes aprender como obtener una
            <span
              nz-tooltip
              [nzTooltipTitle]="tooltipTemplate"
              nzTooltipPlacement="left"
              nzTooltipOverlayClassName="custom-tooltip"
              class="text-semibold cursor-pointer text-primary"
            >
              aquí.
            </span>
          </p>
        </div>
      </nz-card>

    <!-- Template para el tooltip -->
    <ng-template #tooltipTemplate>
      <div class="tooltip-content">
        <p>1. Inicia sesión en tu panel de Odoo</p>
        <p>2. Haz clic en tu avatar (esquina superior derecha)</p>
        <p>3. Selecciona "Preferencias"</p>
        <p>4. Ve a la pestaña "Cuenta"</p>
        <p>5. En la sección "API Keys", haz clic en "Generar nueva clave"</p>
        <p>6. Copia la clave generada y pégala abajo</p>
      </div>
    </ng-template>

    <!-- Formulario -->
    <form [formGroup]="authForm" class="flex flex-column gap-16">
      <!-- Usuario de Odoo -->
      <div class="flex flex-column gap-8">
        <label class="fs-xs text-semibold">Usuario de Odoo *</label>
        <input
          nz-input
          formControlName="login"
          placeholder="Ingrese el usuario de Odoo"
          class="w-100"
        />
        @if (authForm.get('login')?.invalid && authForm.get('login')?.touched) {
          <span class="fs-xs text-error">El usuario es requerido</span>
        }
      </div>

      <!-- API Key de Odoo -->
      <div class="flex flex-column gap-8">
        <label class="fs-xs text-semibold">API Key de Odoo *</label>
        <input
          nz-input
          formControlName="apiKey"
          placeholder="Ingrese la API Key de Odoo"
          class="w-100"
          type="password"
        />
        @if (authForm.get('apiKey')?.invalid && authForm.get('apiKey')?.touched) {
          <span class="fs-xs text-error">La API Key es requerida</span>
        }
      </div>
    </form>

    <!-- Footer del Modal -->
    <div class="flex-center-end gap-12">
      <button
        nz-button
        nzType="default"
        (click)="closeModal()"
        [disabled]="isSubmittingCredentials"
      >
        Cancelar
      </button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="isSubmittingCredentials"
        [disabled]="authForm.invalid"
        (click)="onSubmitCredentials()"
      >
        Configurar Credenciales
      </button>
    </div>
  </div>
</div>


